import React, { useEffect, useState } from "react";
import api from "../../Environment";
import "./WorkspaceShell.css";

/**
 * Partner commissions — real rate + ledger rows (may be empty / $0 when rate is 0).
 * Does not invent totals.
 */
function PartnerCommissionsPanel() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await api.postMethod("studio/partner/commissions", {});
        const body = res && res.data ? res.data : res;
        if (cancelled) return;
        if (!body || body.success === false) {
          setError(
            (body && (body.error || body.error_messages)) ||
              "Unable to load partner commissions"
          );
          setData(null);
        } else {
          setData(body.data || {});
        }
      } catch (e) {
        if (!cancelled) {
          setError((e && e.message) || "Unable to load partner commissions");
          setData(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="ws-panel">
        <p className="ws-muted">Loading commissions…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ws-panel">
        <h2>Commissions</h2>
        <p className="ws-muted" role="alert">
          {error}
        </p>
      </div>
    );
  }

  const items = (data && data.items) || [];
  const ratePct =
    data && data.referral_rate_percent != null
      ? data.referral_rate_percent
      : 0;
  const total = data && data.total != null ? data.total : 0;
  const currency = (data && data.currency) || "USD";

  return (
    <div className="ws-panel">
      <h2>Commissions</h2>
      <p className="ws-muted">
        Referral rate: {Number(ratePct).toFixed(2)}%
        {data && data.partner_name ? ` · ${data.partner_name}` : ""}
      </p>
      <p>
        <strong>
          {Number(total).toFixed(2)} {currency}
        </strong>{" "}
        earned (ledger)
      </p>
      {items.length === 0 ? (
        <p className="ws-muted">
          {(data && data.empty_reason) || "No partner commission rows yet."}
        </p>
      ) : (
        <ul className="ws-list">
          {items.map((row) => (
            <li key={row.id}>
              {row.occurred_at || "—"} · {Number(row.amount).toFixed(2)}{" "}
              {row.currency || currency}
              {row.reference ? ` · ${row.reference}` : ""}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PartnerCommissionsPanel;
